import React from "react";
import Card from 'react-bootstrap/Card';
import Seminario from '../../../assets/images/seminario.svg';
import Seminario2 from '../../../assets/images/seminario2.svg';
import './styles.css';

const Redes = () => {
    return (
        <>
            <div className="container-fluid">
                <div className="row">

                    <div className="col-sm-12">
                        <Card className="card">

                            <div className="container">
                                <Card.Title><h1>Rede Local e Internet: Entendendo os Fundamentos de Conexão</h1></Card.Title>

                                <Card.Body>
                                    <div className="content-info">
                                        <div className="image-info">
                                            <img src={Seminario2} alt="Foto" />
                                            <img src={Seminario} alt="Foto" />
                                        </div>
                                        <div className="info">

                                            <span>
                                                Se você já se perguntou como os dispositivos em sua casa ou escritório estão conectados à internet,
                                                provavelmente está se referindo à combinação entre a Rede Local e a Internet. Neste artigo, 
                                                vamos explorar os fundamentos desses dois conceitos e entender como eles funcionam juntos para 
                                                fornecer conectividade em seu ambiente digital.<br /><br />

                                                <strong>O que é uma Rede Local?</strong><br />
                                                Uma Rede Local, também conhecida como LAN (Local Area Network), refere-se a um grupo de dispositivos
                                                interconectados dentro de um espaço limitado, como uma residência, escritório, escola ou qualquer 
                                                ambiente físico semelhante. A rede local permite a comunicação direta entre esses dispositivos, 
                                                permitindo compartilhamento de arquivos, impressoras, acesso a recursos e outros serviços.<br /><br />
                                                Em uma rede local, os dispositivos são conectados por meio de cabos Ethernet ou por uma rede sem 
                                                fio (Wi-Fi). Um roteador é frequentemente utilizado para gerenciar a conexão entre os dispositivos 
                                                na rede local e a conexão com a internet.<br /><br />

                                                <strong>O que é a Internet? </strong><br />
                                                A Internet, por outro lado, é uma rede global de computadores interconectados que abrange o mundo todo. 
                                                Ela permite que dispositivos de diferentes redes locais e localizações geográficas se comuniquem entre si. 
                                                A Internet oferece acesso a uma vasta gama de recursos e serviços, como sites, e-mail, streaming de mídia, 
                                                jogos online e muito mais.<br /><br />

                                                <strong>Como a Rede Local se conecta à Internet? </strong><br />
                                                A conexão entre a Rede Local e a Internet é estabelecida por meio de um provedor de serviços de internet 
                                                (ISP). O ISP fornece uma conexão de internet de alta velocidade, geralmente por meio de tecnologias como 
                                                fibra óptica, cabo coaxial, DSL ou conexão sem fio.<br /><br />
                                                O roteador desempenha um papel crucial nessa conexão, servindo como uma ponte entre a Rede Local e a 
                                                Internet. Ele recebe o sinal de internet do ISP e o distribui para os dispositivos conectados na rede 
                                                local. Além disso, o roteador também realiza funções de segurança, como a proteção da rede contra ameaças
                                                externas.<br /><br />

                                                <strong>Quais são os benefícios da Rede Local e da Internet? </strong><br />
                                                A Rede Local oferece a conveniência de compartilhar recursos entre dispositivos conectados, como 
                                                impressoras, armazenamento em rede e acesso a arquivos compartilhados. Ela permite a colaboração 
                                                eficiente em um ambiente de trabalho e a utilização conjunta de serviços e dispositivos.<br /><br />
                                                A Internet, por sua vez, proporciona um mundo de informações e possibilidades. Ela conecta você a uma 
                                                infinidade de serviços online, como pesquisa, comunicação, entretenimento e comércio eletrônico. 
                                                Através da Internet, você pode acessar conteúdo global, se comunicar com pessoas em qualquer lugar 
                                                do mundo e aproveitar uma ampla gama de recursos digitais.<br /><br />

                                                <strong>Conclusão: </strong><br />
                                                A Rede Local e a Internet são conceitos fundamentais para entendermos como os dispositivos se conectam 
                                                e interagem no ambiente digital. A Rede Local oferece comunicação e compartilhamento de recursos entre 
                                                dispositivos em um espaço limitado, enquanto a Internet proporciona uma conexão global e acesso a uma 
                                                infinidade de serviços online.
                                            </span>
                                        </div>
                                    </div>
                                </Card.Body>
                            </div>

                        </Card>
                    </div>
                </div>
                
            </div>
            <div className="end"></div>
        </>
    )
}
export default Redes;